import { render, staticRenderFns } from "./sleepTime.vue?vue&type=template&id=36b24ffc&scoped=true&"
import script from "./sleepTime.vue?vue&type=script&lang=js&"
export * from "./sleepTime.vue?vue&type=script&lang=js&"
import style0 from "./sleepTime.vue?vue&type=style&index=0&id=36b24ffc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b24ffc",
  null
  
)

export default component.exports